import CheckIcon from "@material-ui/icons/Check";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import { DAY_MAP, ICON_NAVIGATION } from "app/common/LocalConst";
import { config_resizeImg, handleCopyPhone, hideMiddleDigits, isRoleHisCopyPhone } from "app/common/LocalFunction";
import {
  getFileById,
  uploadFile,
} from "app/services/FileDescriptionExtService";
import imageCompression from "browser-image-compression";
import moment from "moment";
import React from "react";
import { toast } from "react-toastify";

export function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }, wait);
    if (immediate && !timeout) func.apply(context, args);
  };
}

export function isMobile() {
  if (window) {
    return window.matchMedia(`(max-width: 767px)`).matches;
  }
  return false;
}

export function isMdScreen() {
  if (window) {
    return window.matchMedia(`(max-width: 1199px)`).matches;
  }
  return false;
}

function currentYPosition() {
  if (!window) {
    return;
  }
  // Firefox, Chrome, Opera, Safari
  if (window.pageYOffset) return window.pageYOffset;
  // Internet Explorer 6 - standards mode
  if (document.documentElement && document.documentElement.scrollTop)
    return document.documentElement.scrollTop;
  // Internet Explorer 6, 7 and 8
  if (document.body.scrollTop) return document.body.scrollTop;
  return 0;
}

function elmYPosition(elm) {
  var y = elm.offsetTop;
  var node = elm;
  while (node.offsetParent && node.offsetParent !== document.body) {
    node = node.offsetParent;
    y += node.offsetTop;
  }
  return y;
}

export function scrollTo(scrollableElement, elmID) {
  var elm = document.getElementById(elmID);
  if (!elmID || !elm) {
    return;
  }
  var startY = currentYPosition();
  var stopY = elmYPosition(elm);
  var distance = stopY > startY ? stopY - startY : startY - stopY;
  if (distance < 100) {
    scrollTo(0, stopY);
    return;
  }
  var speed = Math.round(distance / 50);
  if (speed >= 20) speed = 20;
  var step = Math.round(distance / 25);
  var leapY = stopY > startY ? startY + step : startY - step;
  var timer = 0;
  if (stopY > startY) {
    for (var i = startY; i < stopY; i += step) {
      setTimeout(
        (function (leapY) {
          return () => {
            scrollableElement.scrollTo(0, leapY);
          };
        })(leapY),
        timer * speed
      );
      leapY += step;
      if (leapY > stopY) leapY = stopY;
      timer++;
    }
    return;
  }
  for (let i = startY; i > stopY; i -= step) {
    setTimeout(
      (function (leapY) {
        return () => {
          scrollableElement.scrollTo(0, leapY);
        };
      })(leapY),
      timer * speed
    );
    leapY -= step;
    if (leapY < stopY) leapY = stopY;
    timer++;
  }
  return false;
}

export function getTimeDifference(date) {
  let difference =
    moment(new Date(), "DD/MM/YYYY HH:mm:ss").diff(
      moment(date, "DD/MM/YYYY HH:mm:ss")
    ) / 1000;

  if (difference < 60) return `${Math.floor(difference)} seconds`;
  else if (difference < 3600) return `${Math.floor(difference / 60)} minutes`;
  else if (difference < 86400) return `${Math.floor(difference / 3660)} hours`;
  else if (difference < 86400 * 30)
    return `${Math.floor(difference / 86400)} days`;
  else if (difference < 86400 * 30 * 12)
    return `${Math.floor(difference / 86400 / 30)} months`;
  else return `${(difference / 86400 / 30 / 12).toFixed(1)} years`;
}

export function generateRandomId() {
  let tempId = Math.random().toString();
  let uid = tempId.substr(2, tempId.length - 1);
  return uid;
}

export function getQueryParam(prop) {
  var params = {};
  var search = decodeURIComponent(
    window.location.href.slice(window.location.href.indexOf("?") + 1)
  );
  var definitions = search.split("&");
  definitions.forEach(function (val, key) {
    var parts = val.split("=", 2);
    params[parts[0]] = parts[1];
  });
  return prop && prop in params ? params[prop] : params;
}

export function classList(classes) {
  return Object.entries(classes)
    .filter((entry) => entry[1])
    .map((entry) => entry[0])
    .join(" ");
}

export function totalHeaderTab(values, type) {
  let totalDrug = 0;
  if (type === 2) {
    totalDrug = values?.syntheticMediReq?.drugOrder?.length || 0;
  } else {
    totalDrug =
      (values?.serviceMediRequest?.drugOrder?.length || 0) +
      (values?.isuranceMediRequest?.drugOrder?.length || 0) +
      (values?.otherMediRequest?.drugOrder?.length || 0);
  }
  let totalMedicalSupply =
    (values?.syntheticMedicalSupplyRequest?.medicalSupplyOrderDtos?.length ||
      0) +
    (values?.consumablesMedicalSupplyRequest?.medicalSupplyOrderDtos?.length ||
      0);
  return {
    totalDrug,
    totalMedicalSupply,
  };
}
export const filterOptions = (options, state) => {
  let newOptions = [];
  options.forEach((element) => {
    // tim theo ten, ma, ten hoat chat
    if (
      element.code?.toLowerCase()?.includes(state.inputValue.toLowerCase()) ||
      element.name?.toLowerCase()?.includes(state.inputValue.toLowerCase()) ||
      element.genericName
        ?.toLowerCase()
        ?.includes(state.inputValue.toLowerCase())
    )
      newOptions.push(element);
  });
  return newOptions;
};

export const cropImage = async (
  imageUrl,
  croppedAreaPixels,
  outputWidth,
  outputHeight
) => {
  const image = await fetch(imageUrl).then((res) => res.blob());
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  const img = new Image();
  img.src = URL.createObjectURL(image);

  return new Promise((resolve) => {
    img.onload = () => {
      const targetWidth = outputWidth || croppedAreaPixels.width;
      const targetHeight = outputHeight || croppedAreaPixels.height;

      canvas.width = targetWidth;
      canvas.height = targetHeight;

      ctx.drawImage(
        img,
        croppedAreaPixels.x,
        croppedAreaPixels.y,
        croppedAreaPixels.width,
        croppedAreaPixels.height,
        0,
        0,
        targetWidth,
        targetHeight
      );

      canvas.toBlob((blob) => {
        const file = new File([blob], "cropped-image.jpg", {
          type: "image/jpeg",
        }); // Tạo file từ blob
        resolve(file); // Trả về file
      }, "image/jpeg");
    };
  });
};

export const toRoman = (num) => {
  const romanNumerals = [
    ["M", 1000],
    ["CM", 900],
    ["D", 500],
    ["CD", 400],
    ["C", 100],
    ["XC", 90],
    ["L", 50],
    ["XL", 40],
    ["X", 10],
    ["IX", 9],
    ["V", 5],
    ["IV", 4],
    ["I", 1],
  ];
  let result = "";
  for (let [letter, value] of romanNumerals) {
    while (num >= value) {
      result += letter;
      num -= value;
    }
  }
  return result;
};

export const divideAmount = (total, divisor) => {
  let full = Math.floor(total / divisor);
  let remainder = total % divisor;
  let roundedFull = Math.floor(full / 1000) * 1000;
  let remind = (full - roundedFull) * divisor + remainder;

  return {
    full: roundedFull || 0,
    remind: remind || 0,
  };
};

export const filterOptionsPatient = (options, state) => {
  options.filter(
    (option) =>
      option?.displayName
        ?.toLowerCase()
        .includes(state?.inputValue?.toLowerCase()) ||
      option?.phoneNumber
        ?.toLowerCase()
        .includes(state?.inputValue?.toLowerCase()) ||
      option?.code?.toLowerCase().includes(state?.inputValue?.toLowerCase())
  );
  return options;
};

export const filterBaseOptions = (options, state) => {
  let newOptions = [];
  options.forEach((element) => {
    // tim theo ten, ma, ten hoat chat
    if (
      element.code?.toLowerCase()?.includes(state.inputValue.toLowerCase()) ||
      element.name?.toLowerCase()?.includes(state.inputValue.toLowerCase())
    )
      newOptions.push(element);
  });
  return newOptions;
};

export const filterStaffOptions = (options, state) => {
  let newOptions = [];
  options.forEach((element) => {
    // tim theo ten, ma, ten hoat chat
    if (
      element.code?.toLowerCase()?.includes(state.inputValue.toLowerCase()) ||
      element.staffName?.toLowerCase()?.includes(state.inputValue.toLowerCase())
    )
      newOptions.push(element);
  });
  return newOptions;
};

export const handleUploadMultiple = async (files) => {
  try {
    const imageFiles = await Promise.all(
      files.map(async (file) => {
        // Nén ảnh
        const compressedBlob = await imageCompression(file, config_resizeImg);
        const compressedFile = new File([compressedBlob], file.name, {
          type: file.type,
        });

        // Upload
        const uploadRes = await uploadFile(compressedFile);
        const fileId = uploadRes?.data?.id;

        // Lấy info theo id
        const fileInfoRes = await getFileById(fileId);

        return {
          path: fileInfoRes?.data,
          id: fileId,
          name: uploadRes?.data?.name,
        };
      })
    );

    return imageFiles;
  } catch (err) {
    console.error("Lỗi trong quá trình upload nhiều ảnh:", err);
    toast.error("Upload quá dung lượng ảnh");
    return [];
  }
};

export const filterCustomerOptions = (options, state) => {
  let newOptions = [];
  options.forEach((option) => {
    if (
      option?.displayName
        ?.toLowerCase()
        .includes(state?.inputValue?.trim()?.toLowerCase()) ||
      option?.phoneNumber
        ?.toLowerCase()
        .includes(state?.inputValue?.trim()?.toLowerCase()) ||
      option?.phoneNumber2
        ?.toLowerCase()
        .includes(state?.inputValue?.trim()?.toLowerCase()) ||
      option?.phoneNumber3
        ?.toLowerCase()
        .includes(state?.inputValue?.trim()?.toLowerCase()) ||
      option?.phoneNumber4
        ?.toLowerCase()
        .includes(state?.inputValue?.trim()?.toLowerCase()) ||
      option?.code
        ?.toLowerCase()
        .includes(state?.inputValue?.trim()?.toLowerCase()) ||
      option?.fullName
        ?.toLowerCase()
        .includes(state?.inputValue?.trim()?.toLowerCase())
    )
      newOptions.push(option);
  });
  return newOptions;
};

export function formatVNDate(isoString, withTime = true) {
  if (!isoString) return "";

  // Thêm "Z" để đảm bảo parse theo UTC
  const date = new Date(isoString.endsWith("Z") ? isoString : isoString + "Z");

  // Format theo múi giờ Việt Nam
  return date.toLocaleString("vi-VN", {
    timeZone: "Asia/Ho_Chi_Minh",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
}

export const checkNowInTimeRange = (startTime, endTime) => {
  const today = moment().format("YYYY-MM-DD");
  const now = moment();

  const start = moment(`${today} ${startTime}`, "YYYY-MM-DD HH:mm:ss");
  const end = moment(`${today} ${endTime}`, "YYYY-MM-DD HH:mm:ss");

  if (end.isBefore(start)) {
    end.add(1, "day");
  }

  return now.isBetween(start, end, null, "[]"); //
};

export const checkIsActiveToday = (obj) => {
  const todayKey = DAY_MAP[new Date().getDay()];
  return obj?.[todayKey] === true;
};
export const checkValidFlashSale = (flashSaleTimes) => {
  const isValid = flashSaleTimes?.some((el) => {
    if (el?.startDaily) return true;

    if (checkIsActiveToday(el)) {
      if (checkNowInTimeRange(el?.startTime, el?.endTime)) return true;
    }
    return false;
  });

  return isValid;
};

export { default as CopyableCodeCell } from "app/common/Component/CopyableCodeCell";

export const PhoneNumberCell = ({ value }) => {
  const [copied, setCopied] = React.useState(false);
  const masked = hideMiddleDigits(value);

  const handleCopy = () => {
    if (!value || copied) return;
    handleCopyPhone(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  if (!value) return <span style={{ color: "#aaa" }}>-</span>;

  const canCopyPhone = isRoleHisCopyPhone();

  return (
    <div style={{ display: "inline-flex", alignItems: "center", gap: 10 }}>
      <span
        style={{ fontWeight: 500, letterSpacing: "0.4px", userSelect: "none" }}
      >
        {masked}
      </span>

      {canCopyPhone && (
      <div
        style={{
          width: 36,
          height: 36,
          borderRadius: "50%",
          backgroundColor: copied ? "rgba(0, 0, 0, 0.08)" : "transparent",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          transition: "all 180ms ease",
        }}
        onClick={handleCopy}
        title={copied ? "Đã sao chép!" : "Sao chép số điện thoại"}
        onMouseDown={(e) => {
          if (copied) return;
          e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0.15)";
          e.currentTarget.style.transform = "scale(0.89)";
        }}
        onMouseUp={(e) => {
          if (copied) return;
          e.currentTarget.style.backgroundColor = "transparent";
          e.currentTarget.style.transform = "scale(1)";
        }}
        onMouseLeave={(e) => {
          if (copied) return;
          e.currentTarget.style.backgroundColor = "transparent";
          e.currentTarget.style.transform = "scale(1)";
        }}
        onTouchStart={(e) => {
          if (copied) return;
          e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0.18)";
          e.currentTarget.style.transform = "scale(0.91)";
        }}
        onTouchEnd={(e) => {
          if (copied) return;
          e.currentTarget.style.backgroundColor = "transparent";
          e.currentTarget.style.transform = "scale(1)";
        }}
      >
        {copied ? (
          <CheckIcon style={{ fontSize: 20, color: "#666" }} />
        ) : (
          <FileCopyIcon style={{ fontSize: 19, color: "#666" }} />
        )}
      </div>
      )}
    </div>
  );
};

export const renderRoles = (roleExs) => {
  let data = roleExs?.map((role, index) => (
    <span key={role?.id}>
      {role?.name}
      {index < roleExs?.length - 1 ? ", " : ""}
    </span>
  ));
  return data;
};

export const renderArrayString = (array, name) => {
  let data = array?.map((item, index) => (
    <span key={item?.id}>
      {item?.[name]}
      {index < array?.length - 1 ? ", " : ""}
    </span>
  ));
  return data;
};

export const convertMenuDtoToNavigation = (menuList) => {
  if (!Array.isArray(menuList)) return [];

  const formatItem = (item, level = 0) => {
    const node = {
      id: item?.id,
      name: item?.name,
      path: item?.path,
      auth: item?.auth || [],
      isVisible: item?.isVisible,
      type: item?.type,
      Icon:
        ICON_NAVIGATION?.find((el) => el?.name === item?.icon)?.icon ||
        LocalOfferIcon,
    };

    // Nếu có children
    if (item?.children && item?.children.length > 0) {
      // [NEW_FIX_L2L3_EMBED] 2026-04-28: Luôn ưu tiên dùng children để đồng bộ với logic Sidebar mới
      const children = item.children.map((child) => formatItem(child, level + 1));
      node.children = children;

      // [OLD_LOGIC_KEPT] Giữ navigation cho các level > 1 để tương thích ngược nếu cần
      if (level !== 1) {
        node.navigation = children;
      }
    }

    return node;
  };

  return menuList.map((root) => formatItem(root));
};
